// extracted by mini-css-extract-plugin
export default {"readMoreLink":"Description_readMoreLink__Gqyl9"};